// 方案切换组件
<template>
    <!-- 等待地图初始化完毕 -->
    <div class="scenario-wrapper">
        <div class="layer-switch-icon" @click="conentShow = !conentShow">
            <i></i>
        </div>
        <div class="scenario" v-show="conentShow">
            <div class="title">
                <h3>选择底图</h3>
                <i class="close" @click="conentShow = false"></i>
            </div>
            <div class="layer-items">
                <div v-for="(item, i) in config" :key="i" :class="[
                            i == scenarioIndex ? 'selectBox' : '',
                            'item-box'
                        ]">
                    <div
                        :class="[
                            'scenario-' + item.type,
                            i == scenarioIndex ? 'select' : '',
                            'layer-item'
                        ]"
                        @click="onSwitchScenario(item, i)"
                    ></div>
                    <span class="layer-title">{{ item.name }}</span>
                </div>
            </div>
            <div class="layer-zj">
                <span>地名</span>
                <i :class="{ selected: showZJ }" @click="showZJ = !showZJ"></i>
            </div>
        </div>
    </div>
</template>

<script>
import mapmixin from '@/mixins/mapmixin.js'
import events from './events'

import { ScenarioView } from './scenarioView.js'

export default {
    mixins: [mapmixin, events],
    data() {
        return {
            config: ScenarioView.ScenariosTypes,
            scenarioIndex: ScenarioView.defaultScenarioIndex,
            conentShow: false,
            showZJ: true,
        }
    },
    created() {
        const config = this.config[this.scenarioIndex]
        config && this.$store.commit('scenario/setScenario', config.type)
    },
    watch:{
        showZJ(newV){
            let layers = this.MapView.map.getStyle().layers
            let zjLayers = []
            layers.map(l => {
                if(l.id.indexOf('zj') != -1
                    || l.id.indexOf('ZJ') != -1
                    || l.id.indexOf('cva') != -1
                    || l.id.indexOf("cia") != -1 
                    || l.id.indexOf("cta") != -1
                ){
                    zjLayers.push(l)
                }
            })
            let flag = newV ? 'visible' : 'none'

            // 设置注记显隐
            zjLayers.map(l => {
                this.MapView.map.setLayoutProperty(l.id, 'visibility', flag)
            })
            console.log(zjLayers, 'zjLayers')
        }
    },
    methods: {
        onSwitchScenario(item, i) {
            if (this.scenarioIndex != i) {
                this.scenarioIndex = i
                this.$store.commit('scenario/setScenario', item.type)

                this.showZJ = true
            }
        }
    }
}
</script>
